import { connect } from "react-redux";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { Doughnut } from "react-chartjs-2";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { getDistributions } from "../../../Redux/reducer/credit-line";
import { getCurrency } from "../../../Redux/reducer/credit-line";
import * as CreditLineAction from "../../../Redux/actions/credit-line";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

export class PieChart extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = { contentReady: false };
  }

  componentDidMount() {
    this._isMounted = true;
    const { getDistributionGraph } = this.props.actions;
    return getDistributionGraph().then(() => {
      if (this._isMounted) {
        this.setState({ contentReady: true });
      }
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getData = () => {
    const { distribution, currency, fromProvider } = this.props;
    var result = {
      labels: [],
      datasets: [],
    };

    if (distribution.list && (currency !== "" || true === fromProvider)) {
      var dataset = {
        data: [],
        backgroundColor: [],
        borderColor: [],
      };
      distribution.list.map((item) => {
        var color = this.getColor(item.status);

        if (
          false !== color &&
          (item.currency.currencyCode == currency ||
            item.currency.currencyCode == "" ||
            true === fromProvider)
        ) {
          result.labels.push(item.description);
          // dataset.data.push(formatNumber(item.amount, item.currency.currencySymbol));
          dataset.data.push(item.amount);
          dataset.backgroundColor.push(color);
          dataset.borderColor.push(color);
        }
      });

      result.datasets.push(dataset);
    }

    return result;
  };

  getColor = (status) => {
    switch (status) {
      case "CLIENTE":
        return "rgba(214, 214, 214, 1)";
      case "PROVEEDORES":
        return "rgba(92, 92, 92, 1)";
      case "BANCO":
        return "rgba(236, 17, 26, 1)";
      case "MONTO_ACEPTADO":
        return "rgba(214, 214, 214, 1)";
      case "MONTO_TRANSITO":
        return "rgba(237, 7, 34, 1)";
      default:
        return false;
    }
  };

  legendClick = (e, item) => {
    // Cliente (Sumar las DDay, Pendientes de Aprobacion + Aprobadas Parcialmente + Aprobadas)
    // Proveedores (Sumar las Validadas + Aceptadas Parcialmente + Aceptadas)
    // Banco (Sumar las Procesadas + Pagadas + Pagadas con Rechazos)
    var graphItem = this.getItem("description", item.text);

    if (null !== graphItem) {
      switch (graphItem.status) {
        case "CLIENTE":
          return this.props.history.push(
            `/bills/all?status=DDAY,PENDING,APPROVED_PARTIALLY,APPROVED`
          );
        case "PROVEEDORES":
          return this.props.history.push(
            `/bills/all?status=VALIDATED,ACCEPTED_PARTIALLY,ACCEPTED`
          );
        case "BANCO":
          return this.props.history.push(
            `/bills/all?status=PROCESSED,PAID,PAID_REJECTED`
          );
        case "MONTO_ACEPTADO":
          return false;
        case "MONTO_TRANSITO":
          return false;
        // case 'MONTO_TRANSITO': return this.props.history.push(`/bills/all?status=VALIDATED,ACCEPTED_PARTIALLY,ACCEPTED`);
        // case 'VALIDATED': return this.props.history.push(`/providerSite/bills?status=VALIDATED`);
        // case 'APPROVED': return this.props.history.push(`/providerSite/bills?status=APPROVED`);
      }
    }
  };

  getItem(property, value) {
    const { distribution } = this.props;
    var result = null;

    distribution.list.map((item) => {
      if (item[property] == value) {
        result = item;
      }
    });

    return result;
  }

  render() {
    const { t, getCurrency, className } = this.props;

    return (
      <div className={`chart-content ${className}`}>
        {this.state.contentReady && getCurrency !== "" ? (
          <React.Fragment>
            <h3 style={{ marginBottom: "-20px" }}>
              {t("dashboard.graph.title")}
            </h3>
            <div>
              <Doughnut
                data={this.getData()}
                options={{
                  plugins: {
                    legend: {
                      display: true,
                      position: "right",
                      labels: {
                        boxWidth: 40,
                        font: {
                          size: 12,
                          style: "normal",
                          family: "Scotia W, sans-serif",
                        },
                        padding: 50,
                        usePointStyle: true,
                      },
                      onClick: (e, item) => this.legendClick(e, item),
                    },
                    cutoutPercentage: 75,
                  },
                  aspectRatio: 1,

                  maintainAspectRatio: true,
                }}
              />
            </div>
          </React.Fragment>
        ) : (
          <div className="linear-loader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        )}
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    distribution: getDistributions(state),
    currency: getCurrency(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(CreditLineAction, dispatch),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatch)(withTranslation()(PieChart))
);
